import React, { useState } from "react";
import { useDispatch } from "react-redux";
import DateTimeRange from "../../../containers/dashboard/DateTimeRange";
import DataTable from "../../Table";
import apiConstants from "../../../constans/apiConstants";
import { formateENGBManually, httpRequestGet, toaster } from "../../../utils/utils";

const Document = () => {
  const [inputValue, setInputValue] = useState({
    source: "",
    channel: "",
  });
  const [data, setData] = useState({});
  const dispatch = useDispatch();

  const handleChange = (value, name) => {
    if (name === "source") {
      setInputValue({
        ...inputValue,
        [name]: value,
      });
    } else if (name === "channel") {
      const letters = /^[a-zA-Z0-9]*$/;
      if (letters.test(value) || value === "") {
        setInputValue({
          ...inputValue,
          [name]: value,
        });
      }
    }
  };

  const searchDocument = (start, end, startTime, endTime) => {
    const startDateNew = formateENGBManually(start, true);
    const endDateNew = formateENGBManually(end, true);
    const fromDate = `${startDateNew}${startTime.startHour}:${startTime.startMin}:${startTime.startSec}`;
    const toDate = `${endDateNew}${endTime.endHour}:${endTime.endMin}:${endTime.endSec}`;
    const path = `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/document/uploadedDocument/list?${"fromDate=" + fromDate + "&toDate=" + toDate + "&source=" + inputValue.source + "&channel=" + inputValue.channel}`;
    dispatch({ type: "LOADER_TRUE" });
    httpRequestGet(path)
      .then((res) => {
        dispatch({ type: "LOADER_FALSE" });
        if (res && res.data) {
          setData(res.data.body);
          toaster("success", res.data.message);
        }
      })
      .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
          toaster("error", err.data.message);
        }
      });
  };

  return (
    <>
      <div className="downloads-page__panel">
        <div className="downloads-page__grid">
          <div className="downloads-page__field downloads-page__field--source">
            <label className="downloads-page__label" htmlFor="document-source">
              Source
            </label>
            <select
              id="document-source"
              name="source"
              className="downloads-page__select"
              value={inputValue.source}
              onChange={(e) => handleChange(e.target.value, e.target.name)}
            >
              <option disabled value="">
                Select
              </option>
              <option value="MSell">MSell</option>
              <option value="D2C">D2C</option>
            </select>
          </div>

          <div className="downloads-page__field">
            <label className="downloads-page__label" htmlFor="document-channel">
              Channel
            </label>
            <input
              id="document-channel"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              className="downloads-page__input"
              value={inputValue.channel}
              name="channel"
              type="text"
              placeholder="Enter channel"
            />
          </div>
        </div>

        <div className="downloads-page__date-range">
          <DateTimeRange searchDocument={searchDocument} />
        </div>
      </div>

      {data && data.length > 0 && (
        <div className="proposal-dashboard__table-section downloads-page__table-section">
          <DataTable
            cellHeaders={["Proposal No", "Policy No", "Doc Header", "Date", "Time"]}
            data={data}
            keys={["proposalNo", "policyNo", "docHeader", "date", "time"]}
            fileName="document"
            addSerialNo={true}
            convertValueToString={true}
            showExcelDownload={true}
            PerPageApiData={false}
            paginationItems={data}
            alwaysShown={false}
          />
        </div>
      )}
    </>
  );
};

export default Document;
